import { LoadState } from "../../constants/enums";
import { IOnlineDsaLimit, IOnlineDsaLimitState } from "./OnlineDsaLimit.types";

export const defaultOnlineDsaLimit: IOnlineDsaLimit = {
	online_dsa_activation_id: 0,
	online_dsa_name: "",
	user_id: 0,
	referral_code: "",
	package_id: 0,
	package_name: "",
	total_activations_limit: 0,
	total_activated: 0,
	increased_limit:0,
	activation_limit_remaining: 0,
	history_description:"",
	comment: "",
	status: "ACTIVE",
	create_dt: null,
	insert_dt: null,
};

export const OnlineDsaLimitInitialState: IOnlineDsaLimitState = {
	list: {
		data: [],
		totalRecords: 0,
		loading: LoadState.NotLoaded,
		error: null,
	},
	onlineDsaLimit: {
		data: defaultOnlineDsaLimit,
		loading: LoadState.NotLoaded,
		error: null,
	},
};
